<template>
  <div class="column content-box settings--content">
    <label class="medium-9 columns settings-item">
      {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.RESUME_INSTRUCTIONS.TITLE') }}
      <textarea
        v-model.trim="resumeInstructions"
        name="resume_instructions"
        class="textlong"
        :placeholder="
          $t(
            'INTEGRATION_SETTINGS.ASSISTENT.FORM.RESUME_INSTRUCTIONS.PLACEHOLDER'
          )
        "
      />
    </label>

    <div class="tab-footer">
      <woot-submit-button
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import assistentTabMixin from '../../mixins/assistentTabMixin';

export default {
  mixins: [assistentTabMixin],
  data() {
    return {
      resumeInstructions: this.assistent.resume_instructions || '',
    };
  },
  methods: {
    async onSubmit() {
      await this.saveAssistent({
        resume_instructions: this.resumeInstructions || '',
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
